import moment from "moment";

export const InspectionType = {
  Annual: "Annual",
  Monthly: "Monthly",
  Quarterly: "Quarterly",
};

export const InspectionTypeDropDown = [
  { key: "Annual", value: "Annual" },
  { key: "Monthly", value: "Monthly" },
  { key: "Quarterly", value: "Quarterly" },
];

export const equipmentCategory = [
  { key: "Crane", value: "Crane" },
  { key: "Derrick", value: "Derrick" },
  { key: "Other", value: "Other" },
];

export const deviceLocationStatusWithoutKey = {
  remainAtWorksite: "Remain at Worksite",
  changesWorksite: "Changes Worksite",
  onbarge: "On Barge",
};

export const deviceLocationStatus = [
  {
    key: deviceLocationStatusWithoutKey.remainAtWorksite,
    value: "(a) Remain at Worksite",
  },
  {
    key: deviceLocationStatusWithoutKey.changesWorksite,
    value: "(b) Changes Worksite",
  },
  { key: deviceLocationStatusWithoutKey.onbarge, value: "(c) On Barge" },
  // { key: "On barge & changes work site" ,value :"(d) On barge & changes work site"}
];
export const inspectionTypes = [
  { key: "annual", value: "Annual" },
  { key: "maritime", value: "Maritime" },
  { key: "prepurchase", value: "Prepurchase" },
  { key: "monthly", value: "Monthly" },
  { key: "checkIn", value: "Check-in" },
  { key: "jumps", value: "Jumps" },
  { key: "incident", value: "Incident" },
  { key: "loadTest", value: "Load Test" },
  { key: "training", value: "Training" },
  { key: "machineEvaluation", value: "Machine Evaluation" },
];

export const datetimeFormats = {
  separatedDateTime: "MM-DD-YYYY | hh:mm A",
  databaseFormat: "YYYY-MM-DD",
  timeIn12HourFormat: "hh:mm A",
  separatedDate: "MM-DD-YYYY",
};

export const inspectionStatusGridClassAndLabel = {
  pending: {
    class: "bg-dark-yellow text-dark-yellow",
    label: "Pending Approval",
  },
  inprogress: { class: "bg-light-purple text-purple", label: "In Progress" },
  upcoming: { class: "bg-light-blue text-blue", label: "Upcoming" },
  docinprogress: { class: "bg-light-sky text-sky", label: "Docs In Process" },
  defiReportWaiting: {
    class: " bg-light-red text-danger defi-report-waiting-tag",
    label: "Inspection Done",
  },
  defiReportReceived: {
    class: "bg-light-sky defi-report-received-tag",
    label: "Inspection Done",
  },
  completed: { class: "bg-ligt-green  text-green", label: "Completed" },
  inspectionDone: {
    class: "bg-light-sky defi-report-received-tag",
    label: "Inspection Done",
  },
  deleted : {
    class: " bg-light-red text-danger defi-report-waiting-tag",
    label: "Deleted",
  }
};

export const inspectionStatusGridClassAndLabelForCustomer = {
  pending: {
    class: "bg-dark-yellow text-dark-yellow",
    label: "Pending Approval",
  },
  inprogress: { class: "bg-light-purple text-purple", label: "In Progress" },
  upcoming: { class: "bg-light-blue text-blue", label: "Upcoming" },
  docinprogress: { class: "bg-light-sky text-sky", label: "Docs In Process" },
  defiReportWaiting: {
    class: " bg-light-red text-danger defi-report-waiting-tag",
    label: "Deficient",
  },
  defiReportReceived: {
    class: "bg-light-sky  defi-report-waiting-tag",
    label: "Docs In Process",
  },
  completed: { class: "bg-ligt-green  text-green", label: "Complete" },
  inspectionDone: {
    class: " bg-light-sky complete-tag",
    label: "Docs In Process",
  },
  deleted : {
    class: " bg-light-red text-danger defi-report-waiting-tag",
    label: "Deleted",
  }
};

export const inspectionStatus = [
  { key: "pending", value: "Pending" },
  { key: "inprogress", value: "In Progress" },
  { key: "upcoming", value: "Upcoming" },
  { key: "docinprogress", value: "Docs In Process" },
  { key: "inspectionDone", value: "Inspection Done" },
  { key: "defiReportWaiting", value: "Deficiency Report Waiting" },
  { key: "completed", value: "Completed" },
];

export const inspectionStatusForUpcoming = [
  { key: "pending", value: "Pending" },
  { key: "inprogress", value: "In Progress" },
  { key: "upcoming", value: "Upcoming" },
  { key: "docinprogress", value: "Docs In Process" },
];

export const machineStatusType = {
  active: "active",
  expired: "expired",
};

export const machineStatusList = [
  { key: machineStatusType.active, value: "Active" },
  { key: machineStatusType.expired, value: "Expired" },
];
export const invoiceStatusList = [
  { key: "due", value: "Due" },
  { key: "paid", value: "Paid" },
];

export const invoiceStatus = {
  due: "due",
  paid: "paid",
};

export const machineExpiredStatus = {
  expired: "Expired",
};

export const inspectionStatusWithoutKey = {
  Pending: "pending",
  Inprogress: "inprogress",
  Upcoming: "upcoming",
  Docinprogress: "docinprogress",
  InspectionDone: "inspectionDone",
  DefiReportWaiting: "defiReportWaiting",
  DefiReportReceived: "defiReportReceived",
  Completed: "completed",
};

export const inspectionTyppeWithoutKey = {
  Annual: "annual",
  Maritime: "maritime",
  Prepurchase: "prepurchase",
  Monthly: "monthly",
  CheckIn: "checkIn",
  Jumps: "jumps",
  Incident: "incident",
  LoadTest: "loadTest",
  Training: "training",
  MachineEvaluation: "machineEvaluation",
};

export const buttonColor = {
  confirmButtonColor: "#FDB711",
  cancelButtonColor: "#dedede",
  color: "#000000",
};

export const navBarTags = {
  dashboard: "dashboard",
  billsAndPayments: "billsAndPayments",
  inspections: "inspections",
  faq: "faq",
  contact: "contact",
  users: "users",
};

export const typeOfBargeWork = {
  Construction: "Construction",
  Commerce: "Commerce",
};

export const typeOfBargeWorkList = [
  { key: typeOfBargeWork.Construction, value: "Construction" },
  { key: typeOfBargeWork.Commerce, value: "Commerce" },
];
